import { useEffect, useRef } from 'react';
import { Form, Formik } from "formik";
import FormikControl from "components/wrapperComponents/FormikControl";
import { useState } from "react";
import { NewsLettersModel } from "model/screensModels/NewsLettersModel";
import { NewsLettersSchema } from "schemas/menu/newsLetters/NewsLettersSchema";
import { NewsLettersService } from "services/menu/newsLettersService/NewsLettersService";
import { msgTypes } from "constants/msgTypes";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CreateNewsLetters = ({ setFlag, updateRecord, loadRecentNewsletter }) => {
  const [viewMode, setViewMode] = useState(false);
  const [initialValues, setInitialValues] = useState(new NewsLettersModel());
  const formikRef = useRef(null);
  const fileInputRef = useRef(null);

  const onSubmit = async (values: NewsLettersModel) => {
    addNewsLetters(values);
  };

  // Prepare Data For API
  useEffect(() => {
    if (updateRecord) {
      setInitialValues(updateRecord)
    }
  }, [updateRecord])

  const prepareRequestBody = async (values: NewsLettersModel) => {
    const prepareData = new NewsLettersModel();

    if ((initialValues.newsLetterId)?.length > 0) {
      prepareData.newsLetterId = initialValues.newsLetterId;
    } else {
      prepareData.newsLetterId = values.newsLetterId ? values.newsLetterId : '';
    }

    prepareData.title = values.title ? values.title : "";
    prepareData.image = values.image ? values.image : "";
    prepareData.description = values.description ? values.description : "";
    prepareData.link = values.link ? values.link : "";

    return prepareData;
  };

  const addNewsLetters = async (values: NewsLettersModel) => {
    const requestData = await prepareRequestBody(values);
    const res = await NewsLettersService.addNewsLetters(requestData);
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setInitialValues(new NewsLettersModel())
      loadRecentNewsletter();
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('imageFile', null);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    }
  };

  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={NewsLettersSchema}
        onSubmit={onSubmit}
        innerRef={formikRef}
      >
        {({ isValid, dirty, isSubmitting, values, setFieldValue }) => (
          <Form>
            <div className='container p-2'>
              <div className="row">
                <div className="col-md-6 position-relative">
                  <FormikControl
                    control="textfield"
                    name="title"
                    label="Title"
                    placeholder="Enter Title"
                    disabled={viewMode}
                    requiredField
                  />
                </div>
                <div className="col-md-6 position-relative ">
                  <FormikControl
                    control="uploadImage"
                    name="imageFile"
                    label="Upload File"
                    tooltip = {[msgTypes.DOCUMENT_TYPE.PDF,msgTypes.DOCUMENT_TYPE.TXT,msgTypes.DOCUMENT_TYPE.JPG, 
                      msgTypes.DOCUMENT_TYPE.JPEG,msgTypes.DOCUMENT_TYPE.PNG, msgTypes.FILE_SIZE_ALLOW_3MB]}
                    nameUrl="image"
                    disabled={viewMode}
                    requiredField
                    inputRef={fileInputRef}
                  />
                </div>

                <div className="col-md-12 textarea-sec   position-relative">
                  <FormikControl
                    control="textfield"
                    name="link"
                    label="Link"
                    placeholder="Enter Page Link"
                    type="text"
                    variant="outlined"
                    disabled={viewMode}
                  />
                </div>

                <div className="col-md-12 textarea-sec   position-relative">
                 
                  
                  <ReactQuill
                                      value={values.description}
                                      onChange={(content: any) =>  setFieldValue("description", content)}
                                      placeholder="Enter Descriptions"
                                      theme="snow"
                                    />
                </div>

              </div>

              <div className="row">
                <div className="col-md-12">
                  {!viewMode ? (
                    <div className="mt-3 d-flex justify-content-end">
                      <div className='pr-2'>
                        <FormikControl
                          control="button"
                          className="btn btn-submit"
                          color="primary"
                          label={values.newsLetterId === '' ? "Save" : "Update"}
                          type="submit"
                          disabled={!dirty || !isValid || isSubmitting}
                        />
                      </div>
                      &nbsp;&nbsp;
                      <div>
                        <FormikControl
                          control="button"
                          className="btn btn-cancel"
                          color="warning"
                          label="Back"
                          type="reset"
                          onClick={() => {
                            setFlag(false);
                          }}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default CreateNewsLetters;
